@if (!item().hidden) {
  <!-- Horizontal Layout -->
  @if (currentLayout === 'horizontal') {
    <li
      (mouseenter)="navCollapse($event)"
      data-username="Berry Dashboard"
      class="nav-item coded-hasmenu"
      [routerLinkActive]="['active']"
      [ngClass]="{ disabled: !isEnabled }"
      ngbTooltip="{{ !isEnabled ? 'You do not have permission to access this page ' : '' }}"
    >
      <a [routerLinkActive]="['active']" href="javascript:" class="nav-link">
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
      <ng-container *ngTemplateOutlet="subMenuContent"></ng-container>
    </li>
  }

  <!-- Vertical Layout -->
  @if (currentLayout === 'vertical') {
    <li
      data-username="Berry Dashboard"
      class="nav-item coded-hasmenu"
      [routerLinkActive]="['active']"
      [ngClass]="{ disabled: !isEnabled }"
      ngbTooltip="{{ !isEnabled ? 'You do not have permission to access this page ' : '' }}"
    >
      <a [routerLinkActive]="['active']" href="javascript:" class="nav-link" (click)="navCollapse($event)">
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
      <ng-container *ngTemplateOutlet="subMenuContent"></ng-container>
    </li>
  }

  <!-- Compact Layout -->
  @if (currentLayout === 'compact') {
    <li
      data-username="Berry Dashboard"
      class="nav-item coded-hasmenu"
      [routerLinkActive]="['active']"
      placement="'top'"
      (click)="subMenuCollapse(item())"
      [ngClass]="{ disabled: !isEnabled }"
      ngbTooltip="{{ !isEnabled ? 'You do not have permission to access this page ' : '' }}"
    >
      <a href="javascript:" class="nav-link">
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
      <ng-container *ngTemplateOutlet="subMenuContent"></ng-container>
    </li>
  }

  <ng-template #itemContent>
    @if (item().icon) {
      <span class="coded-micon">
        <i class="{{ item().icon }}"></i>
      </span>
    }
    <span class="coded-mtext">
      {{ item().title | translate }}
      @if (item().badge && themeLayout === 'horizontal') {
        <span class="badge label" [ngClass]="item().badge.type">
          {{ item().badge.title | translate }}
        </span>
      }
    </span>
  </ng-template>
  <ng-template #subMenuContent>
    <ul class="coded-submenu" [routerLinkActive]="['active']" [ngClass]="item().classes!">
      @for (items of item().children; track items) {
        @if (items.type === 'item') {
          <app-nav-item [item]="items" [parentRole]="item().role && item().role.length > 0 ? item().role : parentRole()" />
        } @else if (items.type === 'collapse') {
          <app-nav-collapse [item]="items" [parentRole]="item().role && item().role.length > 0 ? item().role : parentRole()" />
        }
      }
    </ul>
  </ng-template>
}
